import React from "react";
import { GridToolbarColumnsButton, GridToolbarDensitySelector } from "@mui/x-data-grid-pro";
import { Box } from "@mui/material";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
import { toast } from "react-toastify";

import CustomButton from "../UI/CustomButton";

const CustomToolbar = ({
  reportName = "Report", // Default report name
  selectedRows = [], // Selected rows to be downloaded
  rows = [], // All rows from the table
  columns = [], // All defined columns
  columnVisibilityModel = {}, // Object indicating which columns are visible
}) => {
  // Fields to be excluded from export
  const excludedFields = ["thumbnail", "video"];

  // Returns only the visible and exportable columns.
  const getVisibleColumns = () =>
    columns.filter(
      (col) => columnVisibilityModel[col.field] !== false && !excludedFields.includes(col.field)
    );

  // Exports the visible rows and columns to an XLSX file.
  const exportToXlsx = () => {
    // Show error toaster if there is no data in the table
    if (!rows.length) {
      toast.error("There is no data in the table to download.");
      return;
    }

    try {
      const visibleColumns = getVisibleColumns();

      const dataToExport = (
        selectedRows.length
          ? rows.filter((row) => selectedRows.includes(row.row)) // Match by ID
          : rows
      ).map((row) =>
        visibleColumns.reduce((acc, col) => {
          let value = row[col.field];

          // Replace objects with an empty string (unsupported in Excel)
          if (typeof value === "object") value = "";

          acc[col.headerName || col.field] = value;
          return acc;
        }, {})
      );

      // Create a new worksheet and workbook
      const worksheet = XLSX.utils.json_to_sheet(dataToExport);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

      // Create filename with current timestamp and report name
      const timestamp = dayjs().format("YYYYMMDDTHHmmss");
      const cleanName = reportName.replace(/^\d{8}T\d{6}_/, "");
      const filename = `${timestamp}___${cleanName}.xlsx`;

      // Trigger file download
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Failed to download table data as XLSX:", error);
    }
  };

  return (
    <Box className="flex items-center gap-2 p-2">
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <CustomButton
        size="small"
        onClick={exportToXlsx}
        sx={{
          fontSize: "0.875rem",
          ml: 1,
        }}
      >
        Download Table Data as XLSX
      </CustomButton>
    </Box>
  );
};

export default CustomToolbar;
